module.exports = __webpack_public_path__ + "img/al.eab38620.svg";